<template>
    <div class="c-row settlement-preview">
        <div class="c-tr typo-name settlement-preview__topBar">
            <div class="settlement-preview__sysNo c-td is-1">
                {{ setSettlementId }}
            </div>
            <div
                class="settlement-preview__status d-flex align-items-center mr-2 c-td is-2"
                v-if="!isMonthlyNoteIPHSettlement"
            >
                <a-icon
                    class="mr-1"
                    :class="[!data.paid ? 'text-warning' : 'text-success']"
                    :icon="data.paid ? 'Success' : 'Warning'"
                /><strong>{{ settlementStatus }}</strong>
            </div>
        </div>
        <div class="c-tr">
            <div v-if="showSettlementReadyToShareDetails" class="c-td is-1">
                <div class="typo-name text-uppercase">Nr dokumentu</div>
                <span class="font-weight-bold">{{ data.title }}</span>
            </div>
            <div v-if="showSettlementReadyToShareDetails" class="c-td is-2">
                <div class="typo-name text-uppercase">Data dokumentu</div>
                <span class="font-weight-bold">{{
                    $moment(data.sale_date).format('DD-MM-YYYY')
                }}</span>
            </div>
            <div
                v-if="showSettlementReadyToShareDetails"
                class="c-td is-3"
                style="min-width: 200px"
            >
                <div class="typo-name text-uppercase">Typ dokumentu</div>
                <span class="font-weight-bold">{{ settlementType }}</span>
            </div>
            <div class="c-td is-1">
                <div class="typo-name text-uppercase">Organizator</div>
                <div class="c-fig c-fig--logo">
                    <img
                        :src="data.company.logo.urls.small"
                        class="c-fig__img"
                        alt
                    />
                </div>
            </div>
            <div class="c-td is-2">
                <div
                    v-if="!isMonthlyNoteIPHSettlement"
                    class="typo-name text-uppercase"
                >
                    Okres rozliczeniowy
                </div>
                <div
                    v-if="!isMonthlyNoteIPHSettlement"
                    class="notesTable-ranges"
                >
                    <span>
                        <strong
                            >{{ $moment(data.start_at).format('DD-MM-YYYY') }} -
                            {{
                                $moment(data.end_at).format('DD-MM-YYYY')
                            }}</strong
                        >
                    </span>
                </div>
            </div>
            <div v-if="showSettlementAmount" class="c-td is-3">
                <div class="typo-name text-uppercase">Kwota</div>
                <div class="notesTable-ranges">
                    <span v-if="data.amount_net" class="typo--xl mr-2"
                        ><strong
                            >{{ (+data.amount_net).toFixed(2) }} zł
                            netto</strong
                        ></span
                    >
                    <span
                        v-if="data.amount"
                        class="font-weight-medium typo--lg"
                        :class="{ 'pl-md-3': data.amount_net }"
                        >{{ (+data.amount).toFixed(2) }} zł brutto</span
                    >
                </div>
            </div>
            <div
                class="
                    d-flex
                    justify-content-between
                    flex-grow-1
                    align-items-center
                    flex-wrap
                "
            >
                <div
                    v-if="data.updated_at && data.downloaded"
                    class="c-td pb-3"
                    style="flex: 1"
                >
                    <div
                        class="typo-name text-uppercase pr-3"
                        style="white-space: nowrap"
                    >
                        Data pobrania
                    </div>
                    <span class="font-weight-bold"
                        >&nbsp;{{
                            $moment(data.updated_at).format('DD-MM-YYYY')
                        }}</span
                    >
                </div>
                <div
                    class="
                        notesTable-actions
                        c-td
                        pb-3
                    "
                >
                    <button
                        v-if="!isMonthlyNoteIPHSettlement"
                        @click="downloadReport"
                        class="btn btn-outline-primary ml-0 mr-1 mb-sm-0 mb-2"
                        :class="{
                            disabled: !data.ready_to_share_report
                        }"
                        v-tooltip="{
                            content: downloadSettlementReportButtonTooltip
                        }"
                    >
                        <a-icon
                            v-if="downloadStatusReport !== 'loading'"
                            icon="Xls"
                            class="mr-2"
                        />
                        <button-spinner
                            v-else
                            :status="downloadStatusReport"
                            :on-left="true"
                        />
                        Raport rozliczeniowy
                    </button>
                    <button
                        @click="downloadPdf"
                        class="btn btn-outline-primary mb-sm-0 mb-2"
                        :class="{
                            disabled: !data.ready_to_share_document
                        }"
                        v-tooltip="{
                            content: downloadSettlementPdfButtonTooltip
                        }"
                    >
                        <a-icon
                            v-if="downloadStatus !== 'loading'"
                            icon="Pdf"
                            class="mr-2"
                        />
                        <button-spinner
                            v-else
                            :status="downloadStatus"
                            :on-left="true"
                        />
                        Dokument księgowy
                    </button>
                    <div
                        class="
                            notesTable-check
                            custom-checkbox-lg custom-control custom-checkbox
                            ml-3
                        "
                    >
                        <ui-checkbox-input
                            :name="`settlement-${this.data.id}`"
                            v-model="selectedSettlement"
                        />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { UiCheckboxInput } from '../global/ui'
export default {
    components: { UiCheckboxInput },
    props: {
        data: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            checkboxTest: false
        }
    },
    computed: {
        settlementStatus() {
            let status = ''

            if (!this.data.paid) {
                status = 'Nieopłacony'
            }
            if (this.data.paid) status = 'Opłacony'

            return status
        },
        settlementType() {
            return (
                this.$store.getters.getParametrizationDocumentTypeNameById(
                    this.data.parametrization.document_name_id
                ) || '-'
            )
        },
        downloadSettlementReportButtonTooltip() {
            let tooltip = null
            if (!this.data.ready_to_share_report) {
                tooltip = 'Raport rozliczeniowy jest w trakcie przygotowania.'
            }
            return tooltip
        },
        downloadSettlementPdfButtonTooltip() {
            let tooltip = null
            if (!this.data.ready_to_share_document) {
                tooltip = 'Dokument jest w trakcie przygotowania.'
            }
            return tooltip
        },
        downloadStatus() {
            return this.$store.getters.getActiveSettlement(this.data.id)
        },
        downloadStatusReport() {
            return this.$store.getters.getActiveSettlementReport(this.data.id)
        },
        selectedSettlement: {
            get() {
                return !!this.$store.getters.getSelectedSettlement(this.data.id)
            },
            set(value) {
                this.$store.dispatch('selectSettlement', {
                    id: this.data.id,
                    value
                })
                // if (value === false) {
                //     this.$store.dispatch('setSelectAllPromotions', false)
                // }
            }
        },
        setSettlementId() {
            if (this.isAccountingNoteTypeSettlement) {
                return `Nr rozliczenia: ${this.data.transfer_title
                    ?.split(' ')
                    .slice(-1)}`
            } else {
                return `Nr systemowy: ${this.data.id}`
            }
        },
        showSettlementReadyToShareDetails() {
            return this.isAccountingNoteTypeSettlement
                ? this.data.ready_to_share_document
                : true
        },
        showSettlementAmount() {
            return (
                this.data.parametrization.document_name_id !== 3 &&
                (this.data.amount_net || this.data.amount)
            )
        },
        isAccountingNoteTypeSettlement() {
            return (
                this.data.parametrization.document_name_id === 2 ||
                this.data.parametrization.document_name_id === 5
            )
        },
        isMonthlyNoteTypeSettlement() {
            return (
                this.data.parametrization.document_name_id === 1 ||
                this.data.parametrization.document_name_id === 3 ||
                this.data.parametrization.document_name_id === 4
            )
        },
        isMonthlyNoteIPHSettlement() {
            return (
                this.isMonthlyNoteTypeSettlement &&
                this.data.company.prefix === 'IPH'
            )
        }
    },
    methods: {
        downloadReport() {
            if (this.data.ready_to_share_report) {
                this.$emit('settlementDownload', {
                    id: this.data.id,
                    type: 'settlement_report'
                })
            }
        },
        downloadPdf() {
            if (this.data.ready_to_share_document) {
                this.$emit('settlementDownload', {
                    id: this.data.id,
                    type: 'settlement'
                })
            }
        }
    }
}
</script>
